import { createDecorator } from '../../instantiation/common/instantiation.js';
const IUserDataProfilesService = ( createDecorator('IUserDataProfilesService'));
export { IUserDataProfilesService };
